import axios from "axios";
import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const GET_CERTIFICADOS = `${API_URL}/administrador/certlaborales`

export async function getCertificadosConvocatoria() {
  return await axios({
    method: "GET",
    url: `${GET_CERTIFICADOS}/convocatoria`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error")
    );
}


export async function actualizarCertificados(valores) {
  
  return await axios({
    method: "PUT",
    url: `${GET_CERTIFICADOS}/convocatoria/${valores?.value}`,
    data:{
      xcabpro:valores?.value,
      cconvocator:valores?.label,
      lcerlabant:valores?.lcerlabant,
      lcerlabfor:valores?.lcerlabfor
    }
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error")
    );
}